export default {
	COMUM: {
		GET_INFO_CABECALHO: 'getInfoCabecalho',
		GET_PARAMETRO_SISTEMA: 'getParametroSistema',
		GET_CAMUNDA_PROCESS_KEY: 'getCamundaProcessKey',
		GET_ORGAO_LOGADO: 'getOrgaoLogado',
		GET_CURRENT_TASK: 'getCurrentTask',
	},
	ATA: {
		ATA_ACESSAR_VIEW: 'ataAcessarView',
		GET_ATA_PARA_CABECALHO: 'getAtaParaCabecalho',
	},
}
